import { state, mutations } from './types';

export default {
  [mutations.SET_CHANNELS](s, channels) {
    s[state.CHANNELS] = channels;
  },
  [mutations.SET_CHANNELS_FOR_COLLECTION](s, { collectionId, channels }) {
    s[state.CHANNELS_BY_COLLECTION] = {
      ...s[state.CHANNELS_BY_COLLECTION],
      [collectionId]: channels,
    };
  },
  [mutations.MERGE_USERS](s, users) {
    const updated = { ...s[state.USERS_BY_ID] };
    users.forEach(u => {
      if (u.id != null && u.name != null) updated[u.id] = u.name;
    });
    s[state.USERS_BY_ID] = updated;
  },
  [mutations.SET_MESSAGES](s, messages) {
    s[state.MESSAGES] = messages;
  },
  [mutations.APPEND_MESSAGES](s, newMessages) {
    const existingIds = new Set(s[state.MESSAGES].map(m => m.id));
    const toAdd = newMessages.filter(m => !existingIds.has(m.id));
    s[state.MESSAGES] = [...s[state.MESSAGES], ...toAdd];
  },
  [mutations.SET_ACTIVE_CHANNEL](s, channelName) {
    s[state.ACTIVE_CHANNEL] = channelName;
  },
  [mutations.SET_ACTIVE_COLLECTION_ID](s, collectionId) {
    s[state.ACTIVE_COLLECTION_ID] = collectionId;
  },
  [mutations.SET_POLLING_INTERVAL_ID](s, intervalId) {
    s[state.POLLING_INTERVAL_ID] = intervalId;
  },
  [mutations.SET_LAST_FETCHED_AT](s, ts) {
    s[state.LAST_FETCHED_AT] = ts;
  },

  [mutations.SET_FEED](s, feed) {
    s[state.FEED] = feed;
  },

  [mutations.SET_CHANNEL_READ_AT](s, channelReadAt) {
    s[state.CHANNEL_READ_AT] = channelReadAt;
  },

  [mutations.MARK_CHANNELS_READ](s, channelIds) {
    const now = new Date().toISOString();
    const updated = { ...s[state.CHANNEL_READ_AT] };
    channelIds.forEach(id => {
      updated[id] = now;
    });
    s[state.CHANNEL_READ_AT] = updated;
  },

  [mutations.SET_CHAT_PANEL_OPEN](s, val) {
    s[state.CHAT_PANEL_OPEN] = val;
    localStorage.setItem('chatPanelOpen', JSON.stringify(val));
  },

  [mutations.SET_CHAT_PANEL_WIDTH](s, val) {
    s[state.CHAT_PANEL_WIDTH] = val;
    localStorage.setItem('chatPanelWidth', String(val));
  },

  [mutations.SET_ACTIVE_COLLECTION](s, collection) {
    s[state.ACTIVE_COLLECTION] = collection;
  },

  [mutations.SET_COLLECTION_MEMBERS](s, members) {
    s[state.COLLECTION_MEMBERS] = members;
  },

  [mutations.SET_NEW_CONVERSATION_MODE](s, val) {
    s[state.NEW_CONVERSATION_MODE] = val;
  },

  [mutations.SET_SCROLL_TARGET_MESSAGE_ID](s, target) {
    s[state.SCROLL_TARGET_MESSAGE_ID] = target;
  },
};
